// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"DeleteFontModalContent_modal-wrapper__-FObX"};